export default {
  data() {
    return {
      keyboardShortcuts: {
        /*
        Format: 
        - KeyboardEvent.key: function
        - KeyCode: function
        */
      },
    }
  },
  mounted() {
    // Init event listener
    window.addEventListener('keyup', this.windowKeyUp)
  },
  beforeDestroy() {
    // Remove event listener
    window.removeEventListener('keyup', this.windowKeyUp)
  },
  methods: {
    windowKeyUp(event) {
      if (event.defaultPrevented) {
        return // Should do nothing if the default action has been cancelled
      }

      let handler = null

      if (!handler && event.key !== undefined) {
        // Handle the event with KeyboardEvent.key
        handler = this.keyboardShortcuts[event.key]
      }

      if (!handler && event.keyCode !== undefined) {
        // Handle the event with KeyboardEvent.keyCode
        handler = this.keyboardShortcuts[event.keyCode]
      }

      if (handler && typeof handler == 'function') {
        // Call handler
        handler()

        // Suppress "double action" if event handled
        event.preventDefault();
      }
    },
  }
}
